import gql from 'graphql-tag';

export const REGIST_RESERVE_FROM_WEB = gql`
    mutation(
        $golf_group_code: String
        $member_no: Int
        $golf_code: String
        $plan_id: Int
        $play_date: String
        $cell_number: Int
        $play_number: Int
        $reserve_type: Int
        $cell_id: [Int]
        $cell_player_number: [Int]
        $contact_tel: String
        $request_first_choice: String
        $request_second_choice: String
        $request_third_choice: String
        $request_contact_info: String
        $reserve_no: String
        $point_list: [UseWebPoint]
        $reserve_email: [ReserveEmail]
        $group_info: String
        ){
        RegisterReserveFromWeb(
            golf_group_code: $golf_group_code
            member_no: $member_no
            golf_code: $golf_code
            plan_id: $plan_id
            play_date: $play_date
            cell_number: $cell_number
            play_number: $play_number
            reserve_type: $reserve_type
            cell_id: $cell_id
            cell_player_number: $cell_player_number
            contact_tel: $contact_tel
            request_first_choice: $request_first_choice
            request_second_choice: $request_second_choice
            request_third_choice: $request_third_choice
            request_contact_info: $request_contact_info
            reserve_no: $reserve_no
            point_list: $point_list
            reserve_email: $reserve_email
            group_info: $group_info
            send_admin_email: true
        ){
            result
            error_message
            reserve_no
            reserve_branch_no
        }
    }
`;

export const REGIST_RESERVE_DELETE_CELL = gql`
    mutation(
        $golf_group_code: String
        $member_no: Int
        $golf_code: String
        $plan_id: Int
        $play_date: String
        $cell_number: Int
        $play_number: Int
        $reserve_type: Int
        $cell_id: [Int]
        $cell_player_number: [Int]
        $contact_tel: String
        $request_first_choice: String
        $request_second_choice: String
        $request_third_choice: String
        $request_contact_info: String
        $reserve_no: String
        ){
        RegisterReserveDeleteCell(
            golf_group_code: $golf_group_code
            member_no: $member_no
            golf_code: $golf_code
            plan_id: $plan_id
            play_date: $play_date
            cell_number: $cell_number
            play_number: $play_number
            reserve_type: $reserve_type
            cell_id: $cell_id
            cell_player_number: $cell_player_number
            contact_tel: $contact_tel
            request_first_choice: $request_first_choice
            request_second_choice: $request_second_choice
            request_third_choice: $request_third_choice
            request_contact_info: $request_contact_info
            reserve_no: $reserve_no
        ){
            reserve_no
        }
    }
`;

export const COMPLETE_RESERVE_EMAIL = gql`
    mutation(
        $ReserveEmail: [ReserveEmail]
        ){
        VerifyCompleteReserveEmail(
            ReserveEmailList: $ReserveEmail
            send_admin_emil: true
        ){
            result
        }
    }
`;

export const COMPLETE_RESERVE_CANCEL_EMAIL = gql`
    mutation(
        $reserve_no: String
        ){
        VerifyCompleteReserveCancelEmail(
            reserve_no: $reserve_no
        ){
            result
        }
    }
`;

export const GET_RESERVE_TYPE = gql`
    query($reserve_no: String!){
        GetReserveType(reserve_no: $reserve_no){
            reserveTypeList{
                cell_id
                reserve_type
                member_no
                player_min
            }
        }
    }
`;

export const UPDATE_COMPANION = gql`
    mutation(
        $CompanionList: [CompanionList]
        $ReserveNumbers: [ReserveNumbers]
    ){
        UpdateCompanion(
            UpdateCompanionList: $CompanionList
            ReserveNumbersList: $ReserveNumbers
        ){
            result
        }
    }
`;

export const UPDATE_COMPANION_MAIL_SEND = gql`
    mutation(
        $CompanionList: [CompanionList]
        $ReserveNumbers: [ReserveNumbers]
        $ReserveEmail: [ReserveEmail]
        $reserveNo: String
        $editFlag: Int
    ){
        UpdateCompanionMailSend(
            UpdateCompanionList: $CompanionList
            ReserveNumbersList: $ReserveNumbers
            ReserveEmail: $ReserveEmail
            reserveNo: $reserveNo
            editFlag: $editFlag
            send_admin_email: true
        ){
            result
        }
    }
`;

export const GET_RESERVE_REC = gql`
    query(
        $reserve_no: String!
    ){
        GetReserveRec(
            reserve_no: $reserve_no
        ){
            ReserveRec{
                reserve_no
                reserve_datetime
                golf_code
                plan_id
                play_date
                cell_number
                play_number
                contact_tel
                reserve_type
                reserve_situation
                request_first_choice
                request_second_choice
                request_third_choice
                request_contact_info
            }
        }
    }
`;

export const GET_COURSE_LIST = gql`
    query($golf_group_code: String!, $golf_code: String!)
        {
        GetCoursesList(
            golf_group_code: $golf_group_code
            golf_code: $golf_code
        ){
            course_code
            course_name
        }
    }
`;

export const CHECK_PLAY_DATE = gql`
    query(
        $golf_code: String!,
        $member_no: ID,
        $play_date: String,
        $reserve_no: String
    ){
        CheckPlayDate(
            golf_code: $golf_code
            member_no: $member_no
            play_date: $play_date
            reserve_no: $reserve_no
        ){
            count
        }
    }
`;

export const UPDATE_RESERVE_DETAIL = gql`
    mutation(
        $cellInfos: [AddCells]
    ){
        UpdateReserveDetail(
            cellInfos: $cellInfos
        ){
            result
        }
    }
`;